module.exports = __webpack_public_path__ + "img/名师讲堂.44506ea5.jpg";